import { render, staticRenderFns } from "./ListOfLabEachOPD.vue?vue&type=template&id=4cfed504&scoped=true"
import script from "./ListOfLabEachOPD.vue?vue&type=script&lang=js"
export * from "./ListOfLabEachOPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfed504",
  null
  
)

export default component.exports